import Merge from '../../../assets/merge.svg';

const MergeIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Merge {...props} />;
};

export default MergeIcon;
